import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import "./index.css"
import { Provider } from 'react-redux'
import store from './store'
import ErrorBoundary from './components/ErrorBoundary'

ReactDOM.render(
  <Provider store={store}>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </Provider>,
  document.getElementById('root')
)

/* ثبت سرویس‌ورکر در index.html انجام می‌شود (پیش از باندل). */
